module.exports = __webpack_public_path__ + "img/full4-min.476b7503.png";